import { axios, AxiosResponse } from '~/modules'
import {
  IFetchAnatomopathologicalTest,
  IAnatomopathologicalTest,
  IFetchAnatomopathologicalTestsOfSurgery
} from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchAnatomopathologicalTest = async (
  params: IFetchAnatomopathologicalTest
): Promise<IAnatomopathologicalTest> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/anatomopathological-tests/${pathParams.testId}`)
  const { data }: AxiosResponse<IAnatomopathologicalTest> = response
  return data
}

export const fetchAnatomopathologicalTestsOfSurgery = async (
  params: IFetchAnatomopathologicalTestsOfSurgery
): Promise<IAnatomopathologicalTest[]> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/surgeries/${pathParams.surgeryId}/anatomopathological-tests`)
  const { data }: AxiosResponse<IAnatomopathologicalTest[]> = response
  return data
}
